import React, { useState, useEffect } from 'react';
import { Flex, Text, Box } from 'rebass';
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { keyframes } from '@emotion/core';

const fadeInSlideUp = keyframes`
   0% {
        opacity: 0;
        transform: translateY(20px); /* Starts slightly below its final position */
    }
    100% {
        opacity: 1;
        transform: translateY(0); /* Ends at its normal position */
    }
`;
function BorderedBox({ children, sx = {}, ...props }) {
  return (
    <Flex
      sx={{
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        borderRadius: '10px',
        border: '1px solid #D1D1D1',
        p: '22px 30px',
        bg: 'white',
        ...sx
      }}
      {...props}
    >
      {children}
    </Flex>
  );
}

function CollapsibleSection({
  label,
  defaultOpen = false,
  children,
  sx = {},
  alignItems = 'center',
  mt = '30px',
  isOpen,
  index,
  setIsOpen
}) {

  return (
    <BorderedBox
      flexDirection="column"
      alignItems={alignItems}
      p='15px 30px'
      mt={mt}
      sx={sx}
    >
      {label && (
        <Flex justifyContent="space-between" onClick={() => setIsOpen(isOpen === index ? null : index)} alignItems="flex-start" width="100%" pb={isOpen === index && '25px'}
        >
          <Text
            sx={{
              color: 'codGrey',
              fontFamily: 'Poppins',
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '150%',
            }}
          >{label}</Text>
          <Text minWidth={24} size={24} as={isOpen === index ? IoIosArrowUp : IoIosArrowDown} sx={{ cursor: 'pointer' }} color="#0E0E0E" />
        </Flex>
      )}
      {isOpen === index && <Box sx={{ animation: `${fadeInSlideUp} 1s ease-out forwards` }} maxWidth={600}>
        {children}
      </Box>}
    </BorderedBox>
  );
}

export default CollapsibleSection;
